

























import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 20000,
});
@Component({ name: 'OnBoardingHomeCard' })
export default class OnBoardingHomeCard extends Vue {
  $toastr: any;
  async openOnboarding() {
    this.$router.push('/onboarding');
  }
  get onboardingCompleteDocumetText() {
    if (vxm.jobs.BrandingInfo.ONBOARDING_COMPLETE_TEXT) {
      return vxm.jobs.BrandingInfo.ONBOARDING_COMPLETE_TEXT;
    } 
    return this.$t('onboarding-complete-document-text');
  }
}
